import { createSelector } from 'reselect/lib';

export const authSelector = (state) => (state.auth);

export const isAuthenticatedSelector = createSelector(
    authSelector,
    (auth) => auth.isAuthenticated,
);

export const contactIdSelector = createSelector(
    authSelector,
    (auth) => (
        auth.contactId
    ),
);

export const accessTokenSelector = createSelector(
    authSelector,
    (auth) => auth.memberToken,
);
